import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportBenutzerLive extends GuiListGeneric {
    constructor() {
        super("AktiveBenutzer");
    }
}
